import { DeepPartial } from '../../../models/util.model'
import { OrderBulkUpdateAction } from '../models/order.entity'
import { OrderBulkUpdateField } from '../models/order.types'

/**
 * Init bulk update params
 * @param subject - the bulk update field
 * @returns the params
 */
export function initOrderBulkAction(
  subject: OrderBulkUpdateField,
): DeepPartial<OrderBulkUpdateAction> {
  let action: DeepPartial<OrderBulkUpdateAction> = {}

  switch (subject) {
    case 'CARRIER':
      action = {
        subject: 'CARRIER',
        value: {},
      }
      break
    default:
      break
  }

  return action
}
